// Em-dash used wherever upstream data is not yet available. Centralized so the
// rendering of "missing data" stays consistent across the page.
export function DataPlaceholder() {
  return <span className="text-muted">—</span>;
}
